import { Box } from "@mui/material";
import { stringToColor } from "../../services";

export const Avatar = (props: { 
  string: string; 
  initials?: string;
  size?: "small" | "medium" | "large";
  bgcolor?: string; 
}) => {
  const getSize = () => {
    if (props.size === "small") {
      return "20px";
    }

    if (props.size === "medium" || props.size === undefined) {
      return "40px";
    }

    if (props.size === "large") {
      return "55px";
    }

    return "40px";
  };

  const _size = getSize();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: props.bgcolor || stringToColor(props.string), 
        color: "white",
        height: _size,
        width: _size,
        fontSize: `${parseInt(_size) / 2}px`,
        fontWeight: "bold",
        textShadow: "0px 1px 3px rgba(0, 0, 0, 0.9)",
        borderRadius: "50%",
      }}
      children={props.initials || `${props.string.split(" ")[0][0]}${props.string.split(" ")[1][0]}`}
    />
  );
};
